import React from 'react'
import classNames from 'classnames'
import { translate } from '../../../../../utils'

function JujoSVGMoveForwardBtn({ element_key }) {
  const handleMoveForward = () => {
    if (element_key) {
      const element = document.getElementById(element_key)
      const svg_element = element.closest('svg')

      const group_list = svg_element.querySelector('g').querySelectorAll('g')

      const parsed_groups = Array.from(group_list).filter(
        x => ['fustella', 'guida'].indexOf(x.getAttribute('label')) < 0
      )

      const element_idx = parsed_groups.indexOf(element)

      const next_idx = element_idx + 1
      if (next_idx === 0 || next_idx >= parsed_groups.length) return

      const element_to_move_back = parsed_groups[next_idx]

      svg_element.querySelector('g').insertBefore(element_to_move_back, element)
    }
  }

  return (
    <div>
      <div
        className={classNames(
          'd-flex flex-column align-items-center w-80px w-md-70px border border-md-unset p-1 p-md-0 m-1 m-md-0',
          element_key === null ? 'opacity-5' : ''
        )}
        role="button"
        tabIndex={0}
        onClick={() => handleMoveForward()}
        onKeyPress={() => handleMoveForward()}
      >
        <div className={classNames('fs-8')}>{translate('forward')}</div>
        <div
          className={classNames('background-image move-forward-icon')}
          style={{ width: 25, height: 25 }}
        />
      </div>
    </div>
  )
}

export default JujoSVGMoveForwardBtn
